import React, { useContext } from 'react';
import { Redirect } from 'react-router-dom';
import { UserContext } from '../Auth/UserProvider';
var Home = function () {
    var _a = useContext(UserContext), user = _a.user, twoFactorConfirmed = _a.twoFactorConfirmed;
    var to = user ? (twoFactorConfirmed ? user.getLandingPage() : '/2fa') : '/login';
    return React.createElement(Redirect, { to: to });
};
export default Home;
